export default __webpack_public_path__ + "static/media/ingles.dc583473.png";